/**
 * First we will load all of this project's JavaScript dependencies.
 */

// Bridge the UI elements from jQuery UI that conflict with the ones from Bootstrap.
import tooltip from 'jquery-ui/ui/widgets/tooltip';
$.widget.bridge('uitooltip', tooltip);

import './common/bootstrap';

import '../plugins/jquery_steps/build/jquery.steps';
import '../plugins/datatables/jquery.dataTables.min';
import '../plugins/datatables/dataTables.bootstrap4.min';
import '../plugins/datatables/dataTables.buttons.min';
import '../plugins/datatables/dataTables.responsive.min';
import './frontend/jquery.wizard-init';
import './frontend/review';
import './frontend/search-form';
import SpecialtiesSearch from '@common/specialties';
import LicensesSearch from '@common/licenses';

$(document).ready(() => {
    SpecialtiesSearch.init();
    LicensesSearch.init();
});
